import api from '@/utils/qualityControl/http'
export default {
  get: (url, params = {}) => {
    return new Promise((resolve, reject) => {
      api.api({
        method: 'get',
        url,
        params,
        // 成功
        cb: (res) => {
          resolve(res)
        },
        // 失败
        cbCodeFail: (fail) => {
          reject(fail)
        },
        // 其他错误
        errorCb: (cbNet) => {
          reject(cbNet)
        }
      })
    })
  },
  post: (url, params = {}) => {
    return new Promise((resolve, reject) => {
      api.api({
        method: 'post',
        url,
        params,
        // 成功
        cb: (res) => {
          resolve(res)
        },
        // 失败
        cbCodeFail: (fail) => {
          reject(fail)
        },
        // 其他错误
        errorCb: (cbNet) => {
          reject(cbNet)
        }
        // 是否显示加载中
      })
    })
  }
}
